angular.module('unica_dashboard.dashboard_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// DASHBOARD
		.state('app.dashboard', {
			url: '/dashboard',
			views: {
				'mainContent': {
					templateUrl: './modules/dashboard/templates/dashboard.html',
					controller: 'DashboardController'
				}
			},
			params: {
				need_auth: true
			},
			ncyBreadcrumb: {
				label: 'Global Platform'
			}
		});

});

